import * as actionTypes from './actionTypes';

const initialState = {
  loading: true,
  list: {},
  selectedLicenseListType: 'all',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.getLicensesInit:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.getLicensesSuccess:
      return {
        ...state,
        loading: false,
        list: action.licenses,
      };
    case actionTypes.getLicensesError:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.setLicenseListType:
      return {
        ...state,
        selectedLicenseListType: action.payload,
      };
    default:
      return state;
  }
}
